import { Component, Input } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-view',
    template: `
        <div>
            <div *ngFor="let field of fields">
                <label>{{ field.props.label }}</label>
                <p>
                    {{ model[field.key] | dynamicPipe:field.props.formatter }}
                </p>
            </div>
        </div>
    `
})
export class FormlyView {
    @Input() model: any;
    @Input() fields: FormlyFieldConfig[];

}
